export const getActiveIds = (data, key) => {
    if (data?.node === 'group') {
        const wells = data.children;
        const key = data.key;

        return getActiveIds(wells, key);
    }

    return data.map(item => item.id);
};

export const getRangesData = data => {
    const newData = data.map(item => {
        const { children, DepthStart, DepthStop } = item;

        if (children && !DepthStart && !DepthStop) {
            return getRangesData(children);
        }

        return { DepthStart, DepthStop };
    });

    return newData;
};

export const getDepthValues = data => {
    const DepthStartValues = data.map(({ DepthStart }) => Math.ceil(DepthStart));
    const DepthStopValues = data.map(({ DepthStop }) => Math.ceil(DepthStop));

    const min = Math.min.apply(0, DepthStartValues);
    const max = Math.max.apply(0, DepthStopValues);

    return { min, max };
};

export const getDepthRange = data => {
    if (data?.length === 0) {
        return null;
    }

    const rangeData = getRangesData(data);
    const flatData = rangeData.flat(Infinity);
    const depthRange = getDepthValues(flatData);

    return depthRange;
};
